module.exports = __webpack_public_path__ + "img/9791188502011.4c9a5497.jpg";